import { ToastContainer } from "react-toastify";
import { useContactenos } from "./hooks/useContactenos";
import Loading from "../../../core/utils/loading";
import { format } from "date-fns";

const ContactenosPage = () => {

    const {
        state,
        data,
        form,
        functions,
        paginador
    } = useContactenos();

    return (
        <>
            <ToastContainer />
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Formularios de contacto</h1>
            </div>
            <div className="row mt-5 mb-4">
                <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <div>
                                {
                                    state.loading ? (
                                        <Loading />
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered my-4" style={{ fontSize: "13px" }}>
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th className='text-center' scope="col">Nombre</th>
                                                        <th className='text-center' scope="col">Correo</th>
                                                        <th className='text-center' scope="col">Telefono</th>
                                                        <th className='text-center' scope="col">Servicio</th>
                                                        <th className='text-center' scope="col">Mensaje</th>
                                                        <th className='text-center' scope="col">Activo</th>
                                                        <th className='text-center' scope="col">Fecha</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.nombre}</td>
                                                            <td>{item.correo}</td>
                                                            <td>({item.prefijoTelefono}){item.numeroTelefono}</td>
                                                            <td>{item.servicio}</td>
                                                            <td>{item.mensaje}</td>
                                                            <td className='text-center'>
                                                                <div className="form-check form-switch">
                                                                    {
                                                                        item.activo == '1' ? (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" defaultChecked={true} onChange={() => functions.handdleEstado(item)} />
                                                                        ) : (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" onChange={() => functions.handdleEstado(item)} />
                                                                        )
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>{format(new Date(item.fechaRegistro), 'dd/MM/yyyy hh:mm a')}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="d-flex gap-2 justify-content-end">
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, 1)}
                                                >
                                                    <i className="bi bi-chevron-double-left"></i>
                                                </button>
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.previousPage)}
                                                >
                                                    <i className="bi bi-chevron-left"></i>
                                                </button>
                                                {
                                                    (() => {
                                                        return paginador.itemsPaginator(paginador.paginador?.pages).map((_, currentElementIndex) => {
                                                            if (currentElementIndex >= paginador.inicioPagina && currentElementIndex <= paginador.finPagina) {
                                                                return (
                                                                    <button
                                                                        key={currentElementIndex}
                                                                        className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1 ${paginador.paginador?.currentPage == (currentElementIndex + 1) ? "active" : ""}`}
                                                                        type="button"
                                                                        onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, currentElementIndex + 1)}
                                                                    >
                                                                        {currentElementIndex + 1}
                                                                    </button>
                                                                );
                                                            }
                                                        })
                                                    })()
                                                }
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.nextPage)}
                                                >
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.pages)}
                                                >
                                                    <i className="bi bi-chevron-double-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactenosPage;